import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { lazy, Suspense } from "react";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { AppModeProvider } from "./context/AppModeContext";
import { Toaster } from "sonner";
import BackendDownScreen from "./components/BackendDownScreen";

import Landing from "./pages/Landing";
import Pitch from "./pages/Pitch";
import BankingDocs from "./pages/BankingDocs";
import About from "./pages/About";
import CompanyOverview from "./pages/CompanyOverview";
import FAQ from "./pages/FAQ";
import Partners from "./pages/Partners";
import Contact from "./pages/Contact";
import LandingDark from "./pages/LandingDark";import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import PartnerDemoExchange from "./pages/PartnerDemoExchange";

import PortalShell from "./components/PortalShell";
import SellerDashboard from "./pages/seller/SellerDashboard";
import SellerCatalog from "./pages/seller/SellerCatalog";
import SellerCatalogImport from "./pages/seller/SellerCatalogImport";
import SellerCatalogBroadcast from "./pages/seller/SellerCatalogBroadcast";
import CatalogSetupWizard from "./pages/seller/CatalogSetupWizard";
import SellerInvoices from "./pages/seller/SellerInvoices";
import SellerOrders from "./pages/seller/SellerOrders";
import SellerBuyers from "./pages/seller/SellerBuyers";
import SellerInsurance from "./pages/seller/SellerInsurance";
import SellerDropship from "./pages/seller/SellerDropship";
import SellerWallet from "./pages/seller/SellerWallet";
import SellerAppStore from "./pages/seller/SellerAppStore";
import SellerWms from "./pages/seller/SellerWms";
import SellerMessages from "./pages/seller/SellerMessages";
import SellerSettings from "./pages/seller/SellerSettings";
import SellerShipping from "./pages/seller/SellerShipping";
import SellerComingSoon from "./pages/seller/SellerComingSoon";

import BuyerDashboard from "./pages/buyer/BuyerDashboard";
import BuyerCatalog from "./pages/buyer/BuyerCatalog";
import BuyerOrders from "./pages/buyer/BuyerOrders";
import BuyerCart from "./pages/buyer/BuyerCart";
import BuyerPOGenerator from "./pages/buyer/BuyerPOGenerator";
import BuyerPayments from "./pages/buyer/BuyerPayments";
import BuyerInvoicesList from "./pages/buyer/BuyerInvoicesList";
import BuyerScore from "./pages/buyer/BuyerScore";
import BuyerCapital from "./pages/buyer/BuyerCapital";
import BuyerLoans from "./pages/buyer/BuyerLoans";
import BuyerSuppliers from "./pages/buyer/BuyerSuppliers";
import BuyerSettings from "./pages/buyer/BuyerSettings";
import BuyerAppStore from "./pages/buyer/BuyerAppStore";
import BuyerInventory from "./pages/buyer/BuyerInventory";
import BuyerRfq from "./pages/buyer/BuyerRfq";
import BuyerDropship from "./pages/buyer/BuyerDropship";
import RequireAppInstalled from "./components/RequireAppInstalled";
import SellerSetupGate from "./components/SellerSetupGate";
import { SellerSetupProvider } from "./context/SellerSetupContext";
import { SellerBillingProvider } from "./context/SellerBillingContext";
import SellerBillingGate from "./components/SellerBillingGate";
import SellerOnboardingPlan from "./pages/seller/SellerOnboardingPlan";
import BuyerReports from "./pages/buyer/BuyerReports";
import BuyerAI from "./pages/buyer/BuyerAI";
import BuyerShipping from "./pages/buyer/BuyerShipping";
import BuyerPOInbox from "./pages/buyer/BuyerPOInbox";
import BuyerMessages from "./pages/buyer/BuyerMessages";
import BuyerHubFinancing from "./pages/buyer/BuyerHubFinancing";

import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminCredit from "./pages/admin/AdminCredit";
import AdminFinance from "./pages/admin/AdminFinance";
import AdminBuyers from "./pages/admin/AdminBuyers";
import AdminCommerce from "./pages/admin/AdminCommerce";
import AdminClaims from "./pages/admin/AdminClaims";
import AdminWallets from "./pages/admin/AdminWallets";
import AdminDropship from "./pages/admin/AdminDropship";
import AdminTimeline from "./pages/admin/AdminTimeline";
import AdminInsurance from "./pages/admin/AdminInsurance";
import AdminRiskEngine from "./pages/admin/AdminRiskEngine";
import AdminActivity from "./pages/admin/AdminActivity";
import AdminIntegrations from "./pages/admin/AdminIntegrations";
import AdminShippingAccounts from "./pages/admin/AdminShippingAccounts";
import AdminCatalogApi from "./pages/admin/AdminCatalogApi";
import AdminPlatformFees from "./pages/admin/AdminPlatformFees";
import AdminRevenue from "./pages/admin/AdminRevenue";
import AdminOverrides from "./pages/admin/AdminOverrides";
import AdminQuotas from "./pages/admin/AdminQuotas";
import AdminScopes from "./pages/admin/AdminScopes";
import AdminSecurity from "./pages/admin/AdminSecurity";
import AdminStuckOps from "./pages/admin/AdminStuckOps";
import AdminBankRail from "./pages/admin/AdminBankRail";
import AdminShield from "./pages/admin/AdminShield";
import BankingOnboardingReturn from "./pages/BankingOnboardingReturn";
import AdminTradeScoreDisputes from "./pages/admin/AdminTradeScoreDisputes";
import AdminPortalAccess from "./pages/admin/AdminPortalAccess";
import AdminSupport from "./pages/admin/AdminSupport";
import AdminSupportConsole from "./pages/admin/AdminSupportConsole";
import AdminUnderwriting from "./pages/admin/AdminUnderwriting";
import AdminCompliance from "./pages/admin/AdminCompliance";
import AdminDomains from "./pages/admin/AdminDomains";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminTeamNotifications from "./pages/admin/AdminTeamNotifications";
import AdminWaitlist from "./pages/admin/AdminWaitlist";
import TeamAccept from "./pages/TeamAccept";
import Waitlist from "./pages/Waitlist";
import DropshipLanding from "./pages/preview/DropshipLanding";
import HeroPreview from "./pages/preview/HeroPreview";
import AvatarPreview from "./pages/preview/AvatarPreview";
import DropshipV2Preview from "./pages/preview/DropshipV2Preview";
import DropshipOptionsHub from "./pages/preview/dropship-options/OptionsHub";
import Option1_Marketplace from "./pages/preview/dropship-options/Option1_Marketplace";
import Option2_Bento from "./pages/preview/dropship-options/Option2_Bento";
import Option3_SinglePage from "./pages/preview/dropship-options/Option3_SinglePage";
import Option4_Workspace from "./pages/preview/dropship-options/Option4_Workspace";
import DropshipFinal from "./pages/preview/dropship-options/DropshipFinal";
import AdminCatalog from "./pages/admin/AdminCatalog";
import AdminCatalogImports from "./pages/admin/AdminCatalogImports";
import AdminLegal from "./pages/admin/AdminLegal";
import AdminCoverage from "./pages/admin/AdminCoverage";
import AdminMasterPolicy from "./pages/admin/AdminMasterPolicy";
import AdminInsurancePolicies from "./pages/admin/AdminInsurancePolicies";
import AdminOperations from "./pages/admin/AdminOperations";
import AdminPaymentsOps from "./pages/admin/AdminPaymentsOps";
import AdminShipping from "./pages/admin/AdminShipping";
import AdminWebhooks from "./pages/admin/AdminWebhooks";
import AdminPartnerOrgs from "./pages/admin/AdminPartnerOrgs";
import AdminMgmtFinance from "./pages/admin/AdminMgmtFinance";
import AdminMgmtComms from "./pages/admin/AdminMgmtComms";
import AdminMgmtPlatform from "./pages/admin/AdminMgmtPlatform";
import AdminMgmtHub from "./pages/admin/AdminMgmtHub";
import AdminSellerTrust from "./pages/admin/AdminSellerTrust";
import AdminThreatCenter from "./pages/admin/AdminThreatCenter";
import AdminComplianceDocs from "./pages/admin/AdminComplianceDocs";
import HeyGenStudio from "./pages/admin/HeyGenStudio";
import BankingPortalShell from "./components/BankingPortalShell";
import BankingLogin from "./pages/banking/BankingLogin";
import {
  BankingOverview, BankingTransactions, BankingWebhooks,
  BankingChargebacks, BankingApiHealth,
} from "./pages/banking/BankingPages";
import {
  BankingMoneyMap, BankingReconciliation,
} from "./pages/banking/BankingWavePages";
import {
  BankingRegulatory, BankingPrivacy, BankingDiligencePacket,
} from "./pages/banking/BankingDiligencePages";
import { BankingSecurityPosture } from "./pages/banking/BankingSecurityPosture";
import { BankingCustomerProfile } from "./pages/banking/BankingCustomerProfile";
import {
  BankingAmlTypologies, BankingPolicyTrace, BankingAlerts,
} from "./pages/banking/BankingTier1Pages";
import {
  BankingBehavioral, BankingCyber, BankingOpsDefense,
} from "./pages/banking/BankingTier23Pages";
import {
  BankingModelRisk, BankingBsaOfficer, BankingSanctionsCoverage,
} from "./pages/banking/BankingWave19_20_22Pages";
import {
  BankingPreAuthSimulator, BankingWatchtower, BankingNetworkRisk,
} from "./pages/banking/BankingWave25_26_31Pages";
import {
  BankingEncryptionPosture, BankingAuthPosture, BankingRegulatoryCalendar,
} from "./pages/banking/BankingWave32_33_38Pages";
import {
  BankingPredictive, BankingCrr, BankingGlba, BankingFairLending,
  BankingNacha, BankingLiquidity, BankingDefense,
  BankingExaminerLinks, BankingVendorConcentration, BankingFunnel,
} from "./pages/banking/BankingWaveCloseoutPages";

// Phase PP-2/3/4 partner portals share a single themed shell + login component.
import PartnerPortalShell from "./components/PartnerPortalShell";
import PartnerLogin from "./pages/partner/PartnerLogin";
import {
  LenderOverview, LenderLoanbook, LenderDisbursements, LenderRepayments,
  LenderDelinquencies, LenderAdverseNotices,
} from "./pages/partner/LenderPages";
import {
  LenderWallet, LenderActiveLoans, LenderAging, LenderForecast,
  LenderPendingGrants,
} from "./pages/partner/LenderWavePages";
import LenderBuyerUnderwriting from "./pages/partner/LenderBuyerUnderwriting";
import LenderSellerUnderwriting from "./pages/partner/LenderSellerUnderwriting";
import {
  InsuranceOverview, InsuranceCovers, InsuranceClaims, InsuranceApplications,
} from "./pages/partner/InsurancePages";
import {
  InsuranceWallet, InsuranceLoansRoster, InsuranceTakeoverQueue,
  InsuranceCollections, InsuranceAnalytics, InsuranceForecast,
  InsurancePolicies, InsuranceTakeoverAging, InsuranceEvents,
  InsuranceAdvancedAnalytics,
} from "./pages/partner/InsuranceWavePages";
import {
  CarrierOverview, CarrierShipments,
} from "./pages/partner/CarrierPages";
import PartnerReports from "./pages/partner/PartnerReports";
import {
  Landmark, Shield, Truck as TruckIcon, Banknote as BanknoteIcon,
  ShieldCheck as ShieldCheckIcon, Coins, Activity as ActivityIcon,
  Package as PackageIcon, Send as SendIcon, MapPin,
  FileText as FileTextIcon, AlertTriangle as AlertTriangleIcon,
  Gavel as GavelIcon, LayoutDashboard as LayoutDashboardIcon,
  Shield as ShieldIcon,
  FileWarning as FileWarningIcon, ScrollText as ScrollTextIcon,
  Download as DownloadIcon, Activity as TxnIcon,
  Webhook as WebhookIcon, FileWarning as ChargebackIcon,
} from "lucide-react";

// Dataset catalogues for each portal's Reports page.
const LENDER_DATASETS = [
  { key: "loanbook",        label: "Loan book",       description: "Every credit application + status + terms + rate", icon: FileTextIcon },
  { key: "disbursements",   label: "Disbursements",   description: "Financed invoices (money out the door)", icon: SendIcon },
  { key: "repayments",      label: "Repayments",      description: "Buyer-side wallet txns settling financed invoices", icon: BanknoteIcon },
  { key: "delinquencies",   label: "Delinquencies",   description: "Invoices past due, bucketed 1-15 / 16-30 / 31-60 / 61+", icon: AlertTriangleIcon },
  { key: "adverse-notices", label: "Adverse notices", description: "ECOA / FCRA notices issued by the AI underwriter", icon: GavelIcon },
];

const INSURANCE_DATASETS = [
  { key: "covers",       label: "Covers",       description: "Buyer-cover lifecycle: limits, coverage %, status", icon: Shield },
  { key: "claims",       label: "Claims",       description: "Filed → approved → paid claims with covered amount", icon: FileWarningIcon },
  { key: "applications", label: "Applications", description: "Underwriting applications + policy numbers + premium", icon: ScrollTextIcon },
];

const CARRIER_DATASETS = [
  { key: "shipments", label: "Shipments", description: "Every assigned shipment + status + POD + carrier-invoice fields", icon: PackageIcon },
];

const BANKING_DATASETS = [
  { key: "transactions", label: "Transactions", description: "TabaPay-rail wallet_txns scoped to your bank", icon: TxnIcon },
  { key: "webhooks",     label: "Webhooks",     description: "Inbound TabaPay webhook events + signature/applied flags", icon: WebhookIcon },
  { key: "chargebacks",  label: "Chargebacks",  description: "Disputes pipeline · PII-scrubbed for partner view", icon: ChargebackIcon },
];
import AdminLogin from "./pages/AdminLogin";
import AuthCallback from "./pages/AuthCallback";
import GoogleAuthCallback from "./pages/GoogleAuthCallback";
import PaymentsPricing from "./pages/PaymentsPricing";
import PricingPage from "./pages/PricingPage";
import DemoLanding from "./pages/DemoLanding";
import AgreementOptionsPreview from "./pages/previews/AgreementOptionsPreview";
import PaymentPolicyPreview from "./pages/previews/PaymentPolicyPreview";
import SellerBuyerDrawerPreview from "./pages/preview/SellerBuyerDrawerPreview";
import CatalogSetupPreview from "./pages/preview/CatalogSetupPreview";
import BatchDPreview from "./pages/preview/BatchDPreview";
import BrandPreview from "./pages/preview/BrandPreview";
import LandingV2Preview from "./pages/preview/LandingV2Preview";
import HomeV3Preview from "./pages/preview/HomeV3Preview";
import HomePunchPreview from "./pages/preview/HomePunchPreview";
import HomeCorpPreview from "./pages/preview/HomeCorpPreview";
import MeridianConsole from "./meridian/MeridianConsole";
import HomeV3BuyersPreview from "./pages/preview/HomeV3BuyersPreview";
// LiveSellerLanding / LiveBuyerLanding retired June 2026 — replaced by HomeV3 designs.
// Old landing still viewable at /preview/landing-v2.
import HeroGallery from "./pages/preview/HeroGallery";
import BuyerHeroV2Preview from "./pages/preview/BuyerHeroV2Preview";
import BuyersPage from "./pages/preview/BuyersPage";
import BuyersOffNetworkPreview from "./pages/preview/BuyersOffNetworkPreview";
import WhyVerqoPreview from "./pages/preview/WhyVerqoPreview";
import LandingTiersHub from "./pages/preview/LandingTiersHub";
import BuyersStub from "./pages/preview/BuyersStub";
import NavPreviewHub from "./pages/preview/nav/NavPreviewHub";
import SellerLandingPreview from "./pages/preview/nav/SellerLandingPreview";
import BuyerLandingPreview from "./pages/preview/nav/BuyerLandingPreview";
import SellerLandingTrimmed from "./pages/preview/nav/SellerLandingTrimmed";
import BuyerLandingTrimmed from "./pages/preview/nav/BuyerLandingTrimmed";
import CompanyPartnersPage from "./pages/preview/nav/CompanyPartnersPage";
import SellerPricingPreview from "./pages/preview/nav/SellerPricingPreview";
import BuyerPricingPreview from "./pages/preview/nav/BuyerPricingPreview";
import {
  SellerProductRoute, SellerSolutionsRoute, SellerIndustryRoute, SellerRoleRoute,
  BuyerProductRoute, BuyerSolutionsRoute, BuyerIndustryRoute, BuyerRoleRoute,
  CompanyRoute,
} from "./pages/preview/nav/routes";
import {
  PortalOptionsHub,
  PortalOption1,
  PortalOption2,
  PortalOption3,
  PortalOption4,
  PortalOption5,
  PortalRecommended,
} from "./pages/preview/PortalShowcase";
import {
  PortalJourneyHub,
  PortalJourneySeller,
  PortalJourneyBuyer,
} from "./pages/preview/PortalJourney";
import BankDemoLanding from "./pages/bank-demo/BankDemoLanding";
import BankDemoBuyerFlow from "./pages/bank-demo/BankDemoBuyerFlow";
import BankDemoSellerFlow from "./pages/bank-demo/BankDemoSellerFlow";
import WalletKycPreview from "./pages/previews/WalletKycPreview";
import RegisterFlowPreview from "./pages/previews/RegisterFlowPreview";
import RegisterBoostScorePreview from "./pages/previews/RegisterBoostScorePreview";
import MessagingRealtimePreview from "./pages/previews/MessagingRealtimePreview";
import ReturnsRmaPreview from "./pages/previews/ReturnsRmaPreview";
import SellerProfilePreview from "./pages/previews/SellerProfilePreview";
import SellerProfileEntryPointsPreview from "./pages/previews/SellerProfileEntryPointsPreview";
import SellerProfilePopupOptionsPreview from "./pages/previews/SellerProfilePopupOptionsPreview";
import SellerProfilePage from "./pages/SellerProfilePage";
import StorefrontCatalog from "./pages/StorefrontCatalog";
import CashflowStripPreview from "./pages/previews/CashflowStripPreview";
import FundsFlowPreview from "./pages/previews/FundsFlowPreview";
import PackListReconciliationPreview from "./pages/previews/PackListReconciliationPreview";
import InvoiceAdjustmentPreview from "./pages/previews/InvoiceAdjustmentPreview";
import PrebookFlowPreview from "./pages/previews/PrebookFlowPreview";
import VerqoBrandPreview from "./pages/previews/VerqoBrandPreview";
import LogoVariantsPreview from "./pages/preview/LogoVariantsPreview";
import BuyerPatternsPreview from "./pages/preview/BuyerPatternsPreview";
import VerqoLowercasePreview from "./pages/previews/VerqoLowercasePreview";

// Catalog template mockups (Feb 2026) — static visual previews of the
// 4 catalog templates + Catalog Designer for stakeholder approval.
import CatalogTemplatesHub from "./pages/preview/catalog/CatalogTemplatesHub";
import CatalogDesignerPreview from "./pages/preview/catalog/CatalogDesignerPreview";
import LinesheetPreview from "./pages/preview/catalog/LinesheetPreview";
import EditorialPreview from "./pages/preview/catalog/EditorialPreview";
import CatalogSheetPreview from "./pages/preview/catalog/CatalogSheetPreview";
import ShowcasePreview from "./pages/preview/catalog/ShowcasePreview";
import LegacyStorefrontCatalogPreview from "./pages/preview/catalog/LegacyStorefrontCatalogPreview";

// Shopify embedded apps (lazy — Polaris CSS is heavy + only needed
// when the user is inside Shopify Admin).
const ShopifySupplierApp = lazy(() => import("@shopify-app/supplier/SupplierApp"));
const ShopifyRetailerApp = lazy(() => import("@shopify-app/retailer/RetailerApp"));
import OrdersTabsRedesignPreview from "./pages/previews/OrdersTabsRedesignPreview";
import BankInstructionsPreview from "./pages/previews/BankInstructionsPreview";
import Architecture from "./pages/Architecture";
import FlowOfFunds from "./pages/FlowOfFunds";
import InvestorPitch from "./pages/InvestorPitch";
import InvestorPitchV2 from "./pages/InvestorPitchV2";
import InvestorPitchV4 from "./pages/InvestorPitchV4";
import GTMStrategy from "./pages/GTMStrategy";
import InvestorPitchLegacy from "./pages/InvestorPitchLegacy";
import AcceptInvite from "./pages/invite/AcceptInvite";
import TwoDoneBridge from "./pages/TwoDoneBridge";
import InsuranceLegal from "./pages/InsuranceLegal";
import Privacy from "./pages/legal/Privacy";
import CreditDisclosure from "./pages/legal/CreditDisclosure";
import TradeScoreMethodology from "./pages/legal/TradeScoreMethodology";
import Terms from "./pages/legal/Terms";
import AcceptableUse from "./pages/legal/AcceptableUse";
import Cookies from "./pages/legal/Cookies";
import Esign from "./pages/legal/Esign";
import AmlKyc from "./pages/legal/AmlKyc";
import DemoNda from "./pages/legal/DemoNda";
import DoNotSell from "./pages/legal/DoNotSell";
import Dmca from "./pages/legal/Dmca";
import CookieConsent from "./components/CookieConsent";
import ReConsentGate from "./components/ReConsentGate";
import PublicPO from "./pages/PublicPO";
import Roadmap from "./pages/Roadmap";
import { SupplierProvider } from "./context/SupplierContext";
import { SellerProfileDrawerProvider } from "./context/SellerProfileDrawerContext";
import { TenantHostProvider, useTenantHost } from "./context/TenantHostContext";
import RequestAccess from "./pages/RequestAccess";

// HostGate — when the visitor lands on a seller's vanity host (custom domain
// or auto subdomain), render the seller's branded "Request Access" page
// regardless of who's logged in. The storefront is a closed network —
// even an authenticated verqo user (seller, buyer, admin) should see the
// SELLER'S brand on their domain, never the generic verqo marketing site.
// (RequestAccess has its own "Already a buyer? Sign in →" link at the top
// for logged-in users who want to go back to verqo.com/login.)
//
// Only the root path is wrapped in HostGate — every other route (/login,
// /buyer/*, /seller/*, /admin/*, …) bypasses this so verqo's own portals
// stay reachable from any host.
function HostGate({ children }) {
  const { loading, isTenantHost } = useTenantHost();
  if (loading) return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Loading…</div>;
  if (isTenantHost) return <RequestAccess/>;
  return children;
}


function RoleRoute({ role, children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Loading…</div>;
  // Plan SX · admin routes redirect to the admin sign-in (not the generic /login)
  if (!user) return <Navigate to={role === "admin" ? "/admin/login" : "/login"} replace />;
  if (role && user.role !== role) {
    // Cross-role team-membership escape hatch (Feb 2026):
    // A buyer who's been invited to a seller's team CAN access /seller/*
    // (and vice-versa) provided they have an active team_members row at
    // a tenant whose owner has the matching role. This is how martha (a
    // buyer at "green herb") can also work as an Operator at BRND DIRECT.
    const hasCrossRoleAccess = (user.team_memberships || []).some(
      (m) => m.owner_role === role && m.status === "active",
    );
    if (hasCrossRoleAccess) return children;
    return <Navigate to={`/${user.role}`} replace />;
  }
  return children;
}

// Partner portal gate — admins ALWAYS bypass for support/impersonation.
// Other roles are bounced to their own portal home. Unauthenticated
// users get redirected to the portal-specific login (e.g. /lender/login
// for /lender/*) so the UX is consistent across partner types.
function PartnerRoleRoute({ roles, children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Loading…</div>;
  if (!user) {
    // Infer the portal slug from the first segment of the current pathname.
    const seg = (location.pathname.split("/").filter(Boolean)[0] || "banking").toLowerCase();
    const knownSlugs = new Set(["banking", "lender", "insurance", "carrier"]);
    const slug = knownSlugs.has(seg) ? seg : "banking";
    return <Navigate to={`/${slug}/login`} replace />;
  }
  if (user.role === "admin") return children;
  if (!roles.includes(user.role)) return <Navigate to={`/${user.role}`} replace />;
  return children;
}

// Auth-required, but role-agnostic — the nested PortalShell renders the
// correct sidebar for the current user. Used by /roadmap so buyers, sellers
// and admins all land on the same page.
function AnyRoleRoute({ children }) {
  const { user } = useAuth();
  if (user === undefined) return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// Wraps PortalShell with the current user's role, used as a layout route
// for cross-portal pages like /roadmap. Children render inside the shell's
// <Outlet/> so the sidebar/topbar stay consistent.
function AnyRolePortalShell() {
  const { user } = useAuth();
  return (
    <SupplierProvider>
      <PortalShell role={user.role} />
    </SupplierProvider>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <TenantHostProvider>
        <AppModeProvider>
          <Toaster position="top-right" richColors />
          <BackendDownScreen />
          {/* Consent collected inline on /register (and /login) — no global popups */}
          <Routes>
          {/* Live seller landing — wraps LandingV2Preview with mega-menu header + footer.
              Feb 2026 · main content sections all preserved. */}
          <Route path="/" element={<HostGate><HomeV3Preview /></HostGate>} />
          {/* /preview/os-positioning was a temporary side-by-side preview
              for the OS-positioning hero diagram copy swap; the swap is now
              the default for `/`, so the preview route is removed. */}
          <Route path="/buyers" element={<HostGate><HomeV3BuyersPreview /></HostGate>} />
          <Route path="/about" element={<About />} />
          {/* Sponsor-bank diligence portal — separate experience from the
              main marketing site so banks aren't pulled into seller/buyer
              funnels. `/diligence` is the primary URL; `/company` kept as
              alias for any links already shared. Both `noindex` so neither
              shows up on Google. */}
          <Route path="/diligence" element={<CompanyOverview />} />
          <Route path="/company"   element={<CompanyOverview />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/landing-legacy" element={<Landing />} />
          {/* /pitch is the canonical investor deck URL (verqo.com/pitch).
              Now serves the 24-slide v4 deck, transcribed from
              Verqo_Investor_Pitch_v4.pdf. Previous decks: 22-slide at /pitch/v2,
              11-slide at /pitch/v1, long-scroll at /pitch/legacy. */}
          <Route path="/pitch" element={<InvestorPitchV4 />} />
          <Route path="/gtm" element={<GTMStrategy />} />
          <Route path="/pitch/v2" element={<InvestorPitchV2 />} />
          <Route path="/pitch-v2" element={<InvestorPitchV2 />} />
          <Route path="/pitch/v1" element={<InvestorPitch />} />
          <Route path="/pitch/legacy" element={<Pitch />} />
          <Route path="/banking-docs" element={<BankingDocs />} />
          <Route path="/preview/dark" element={<LandingDark />} />
          <Route path="/preview/hero" element={<HeroPreview />} />
          <Route path="/preview/avatars" element={<AvatarPreview />} />
          <Route path="/preview/dropship-v2" element={<DropshipV2Preview />} />
          <Route path="/preview/dropship-options"    element={<DropshipOptionsHub />} />
          <Route path="/preview/dropship-options/1"  element={<Option1_Marketplace />} />
          <Route path="/preview/dropship-options/2"  element={<Option2_Bento />} />
          <Route path="/preview/dropship-options/3"  element={<Option3_SinglePage />} />
          <Route path="/preview/dropship-options/4"  element={<Option4_Workspace />} />
          <Route path="/preview/dropship-final"      element={<DropshipFinal />} />
          <Route path="/preview/seller-buyer-drawer" element={<SellerBuyerDrawerPreview />} />
          <Route path="/preview/catalog-setup" element={<CatalogSetupPreview />} />
          <Route path="/preview/agreement-options" element={<AgreementOptionsPreview />} />
          <Route path="/preview/payment-policy" element={<PaymentPolicyPreview />} />
          <Route path="/preview/batch-d" element={<BatchDPreview />} />
          <Route path="/preview/brand" element={<BrandPreview />} />
          <Route path="/preview/home-v3" element={<HomeV3Preview />} />
          <Route path="/preview/home-v3-buyers" element={<HomeV3BuyersPreview />} />
          <Route path="/preview/home-punch" element={<HomePunchPreview />} />
          <Route path="/preview/home-corp" element={<HomeCorpPreview />} />

          {/* Meridian — financial trust & control plane console (separate Postgres store) */}
          <Route path="/meridian" element={<MeridianConsole />} />
          <Route path="/preview/landing-v2" element={<LandingV2Preview theme="tier1" />} />
          <Route path="/preview/landing-v2-tier2" element={<LandingV2Preview theme="tier2" />} />
          <Route path="/preview/landing-v2-tier3" element={<LandingV2Preview theme="tier3" />} />
          <Route path="/preview/landing-v3-a"      element={<LandingV2Preview variant="plan-a" />} />
          <Route path="/preview/landing-v3-a-lean" element={<LandingV2Preview variant="plan-a-lean" />} />
          <Route path="/preview/landing-v3-c"      element={<LandingV2Preview variant="plan-c" />} />
          <Route path="/preview/landing-v3-ac"     element={<LandingV2Preview variant="plan-ac" />} />
          <Route path="/preview/buyer-hero-v2"     element={<BuyerHeroV2Preview />} />
          <Route path="/preview/landing-with-buyer-v2" element={<LandingV2Preview theme="tier2" variant="plan-a-lean" buyerHeroV2 />} />

          {/* Hero design gallery (Feb 2026) — 6 alternative hero designs */}
          <Route path="/preview/heroes"           element={<HeroGallery />} />
          <Route path="/preview/hero/pattern-1"   element={<LandingV2Preview theme="tier2" variant="plan-a-lean" buyerHeroV2 hideBanner heroVariant="pattern-1" />} />
          <Route path="/preview/hero/pattern-2"   element={<LandingV2Preview theme="tier2" variant="plan-a-lean" buyerHeroV2 hideBanner heroVariant="pattern-2" />} />
          <Route path="/preview/hero/pattern-3"   element={<LandingV2Preview theme="tier2" variant="plan-a-lean" buyerHeroV2 hideBanner heroVariant="pattern-3" />} />
          <Route path="/preview/hero/pattern-4"   element={<LandingV2Preview theme="tier2" variant="plan-a-lean" buyerHeroV2 hideBanner heroVariant="pattern-4" />} />
          <Route path="/preview/hero/pattern-5"   element={<LandingV2Preview theme="tier2" variant="plan-a-lean" buyerHeroV2 hideBanner heroVariant="pattern-5" />} />
          <Route path="/preview/hero/combo"       element={<LandingV2Preview theme="tier2" variant="plan-a-lean" buyerHeroV2 hideBanner heroVariant="combo" />} />
          {/* v2 final · 3 rotating-word strategies — keep existing diagram/stats */}
          <Route path="/preview/hero/v2-a"        element={<LandingV2Preview theme="tier2" variant="plan-a-lean" buyerHeroV2 hideBanner heroVariant="v2-a" />} />
          <Route path="/preview/hero/v2-b"        element={<LandingV2Preview theme="tier2" variant="plan-a-lean" buyerHeroV2 hideBanner heroVariant="v2-b" />} />
          <Route path="/preview/hero/v2-c"        element={<LandingV2Preview theme="tier2" variant="plan-a-lean" buyerHeroV2 hideBanner heroVariant="v2-c" />} />
          <Route path="/preview/hero/v2-final"    element={<LandingV2Preview theme="tier2" variant="plan-a-lean" buyerHeroV2 hideBanner heroVariant="v2-final" />} />
          {/* Buyer-landing hero v2 preview (rotating headline) */}
          <Route path="/preview/buyers-hero-v2"   element={<BuyersPage heroVariant="v2-final" />} />
          <Route path="/preview/why-verqo" element={<WhyVerqoPreview />} />
          <Route path="/preview/landing-tiers" element={<LandingTiersHub />} />
          <Route path="/preview/buyers" element={<BuyersStub />} />
          <Route path="/preview/buyers-off-network" element={<BuyersOffNetworkPreview />} />
          <Route path="/preview/portal-options" element={<PortalOptionsHub />} />
          <Route path="/preview/portal-options/recommended" element={<PortalRecommended />} />
          <Route path="/preview/portal-options/1" element={<PortalOption1 />} />
          <Route path="/preview/portal-options/2" element={<PortalOption2 />} />
          <Route path="/preview/portal-options/3" element={<PortalOption3 />} />
          <Route path="/preview/portal-options/4" element={<PortalOption4 />} />
          <Route path="/preview/portal-options/5" element={<PortalOption5 />} />
          <Route path="/preview/portal-journey" element={<PortalJourneyHub />} />
          <Route path="/preview/portal-journey/seller" element={<PortalJourneySeller />} />
          <Route path="/preview/portal-journey/buyer" element={<PortalJourneyBuyer />} />
          <Route path="/preview/wallet-kyc" element={<WalletKycPreview />} />
          <Route path="/preview/register-flow" element={<RegisterFlowPreview />} />
          <Route path="/preview/register-boost-score" element={<RegisterBoostScorePreview />} />
          <Route path="/preview/messaging-realtime" element={<MessagingRealtimePreview />} />
          <Route path="/preview/returns-rma" element={<ReturnsRmaPreview />} />
          <Route path="/preview/seller-profile" element={<SellerProfilePreview />} />
          <Route path="/preview/seller-profile-entrypoints" element={<SellerProfileEntryPointsPreview />} />
          <Route path="/preview/seller-profile-popup-options" element={<SellerProfilePopupOptionsPreview />} />
          <Route path="/preview/cashflow-strip" element={<CashflowStripPreview />} />
          <Route path="/preview/funds-flow" element={<FundsFlowPreview />} />
          <Route path="/preview/pack-list-reconciliation" element={<PackListReconciliationPreview />} />
          <Route path="/preview/invoice-adjustment" element={<InvoiceAdjustmentPreview />} />
          <Route path="/preview/prebook-flow" element={<PrebookFlowPreview />} />
          <Route path="/preview/verqo-brand" element={<VerqoBrandPreview />} />
          <Route path="/preview/logo-variants" element={<LogoVariantsPreview />} />
          <Route path="/preview/buyer-patterns" element={<BuyerPatternsPreview />} />
          <Route path="/preview/verqo-lowercase" element={<VerqoLowercasePreview />} />

          {/* Marketing mega-menu nav — preview build (Feb 2026)
              Preview-only routes at /preview/nav/*. Nothing here is live yet.
              Reviewer walks pages, approves, then we ship into / and /buyers. */}
          <Route path="/preview/nav"                             element={<NavPreviewHub />} />
          <Route path="/preview/nav/seller"                      element={<SellerLandingPreview />} />
          <Route path="/preview/nav/buyers"                      element={<BuyerLandingPreview />} />
          <Route path="/preview/nav/seller-trimmed"              element={<SellerLandingTrimmed />} />
          <Route path="/preview/nav/buyers-trimmed"              element={<BuyerLandingTrimmed />} />
          <Route path="/preview/nav/pricing"                     element={<SellerPricingPreview />} />
          <Route path="/preview/nav/buyers/pricing"              element={<BuyerPricingPreview />} />
          <Route path="/preview/nav/product/:slug"               element={<SellerProductRoute />} />
          <Route path="/preview/nav/solutions/:slug"             element={<SellerSolutionsRoute />} />
          <Route path="/preview/nav/solutions/industry/:slug"    element={<SellerIndustryRoute />} />
          <Route path="/preview/nav/solutions/role/:slug"        element={<SellerRoleRoute />} />
          <Route path="/preview/nav/buyers/product/:slug"        element={<BuyerProductRoute />} />
          <Route path="/preview/nav/buyers/solutions/:slug"      element={<BuyerSolutionsRoute />} />
          <Route path="/preview/nav/buyers/solutions/industry/:slug" element={<BuyerIndustryRoute />} />
          <Route path="/preview/nav/buyers/solutions/role/:slug" element={<BuyerRoleRoute />} />
          <Route path="/preview/nav/company/:slug"               element={<CompanyRoute />} />

          {/* Marketing sub-pages — SHIPPED LIVE (Feb 2026)
              Main landings (/ and /buyers) intentionally left unchanged.
              These slug routes power the mega-menu experience. */}
          <Route path="/product/:slug"                            element={<SellerProductRoute />} />
          <Route path="/solutions/:slug"                          element={<SellerSolutionsRoute />} />
          <Route path="/solutions/industry/:slug"                 element={<SellerIndustryRoute />} />
          <Route path="/solutions/role/:slug"                     element={<SellerRoleRoute />} />
          <Route path="/buyers/product/:slug"                     element={<BuyerProductRoute />} />
          <Route path="/buyers/solutions/:slug"                   element={<BuyerSolutionsRoute />} />
          <Route path="/buyers/solutions/industry/:slug"          element={<BuyerIndustryRoute />} />
          <Route path="/buyers/solutions/role/:slug"              element={<BuyerRoleRoute />} />
          <Route path="/buyers/pricing"                           element={<BuyerPricingPreview />} />
          <Route path="/company/partners"                          element={<CompanyPartnersPage />} />
          <Route path="/company/:slug"                            element={<CompanyRoute />} />

          {/* Catalog template mockups (Feb 2026 · approval pass) */}
          <Route path="/preview/catalog" element={<CatalogTemplatesHub />} />
          <Route path="/preview/catalog/designer" element={<CatalogDesignerPreview />} />
          <Route path="/preview/catalog/linesheet" element={<LinesheetPreview />} />
          <Route path="/preview/catalog/editorial" element={<EditorialPreview />} />
          <Route path="/preview/catalog/catalog-sheet" element={<CatalogSheetPreview />} />
          <Route path="/preview/catalog/showcase" element={<ShowcasePreview />} />
          <Route path="/preview/catalog/legacy-storefront" element={<LegacyStorefrontCatalogPreview />} />

          {/* Shopify embedded apps — Phase 1 scaffold. Mounted under
              `/shopify/{supplier,retailer}/*` so Shopify Admin can iframe
              them via the App URL configured in the Partner Dashboard. */}
          <Route
            path="/shopify/supplier/*"
            element={
              <Suspense fallback={null}>
                <ShopifySupplierApp />
              </Suspense>
            }
          />
          <Route
            path="/shopify/retailer/*"
            element={
              <Suspense fallback={null}>
                <ShopifyRetailerApp />
              </Suspense>
            }
          />
          <Route path="/preview/orders-tabs-redesign" element={<OrdersTabsRedesignPreview />} />
          <Route path="/preview/bank-instructions" element={<BankInstructionsPreview />} />
          <Route path="/login" element={<Login />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/payments-pricing" element={<PaymentsPricing />} />
          <Route path="/team/accept" element={<TeamAccept />} />
          <Route path="/waitlist"    element={<Waitlist />} />
          <Route path="/dropship" element={<HostGate><DropshipLanding /></HostGate>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/login/magic" element={<AdminLogin />} />
          <Route path="/admin/sso/callback" element={<AuthCallback />} />
          <Route path="/auth/callback" element={<GoogleAuthCallback />} />
          <Route path="/register" element={<Register />} />
          <Route path="/auth/forgot-password" element={<ForgotPassword />} />
          <Route path="/auth/reset/:token" element={<ResetPassword />} />
          <Route path="/auth/verify" element={<VerifyEmail />} />
          <Route path="/partner-demo/:token" element={<PartnerDemoExchange />} />
          <Route path="/legal/insurance" element={<InsuranceLegal />} />
          <Route path="/legal/privacy" element={<Privacy />} />
          <Route path="/legal/credit-disclosure" element={<CreditDisclosure />} />
          <Route path="/legal/trade-score" element={<TradeScoreMethodology />} />
          <Route path="/legal/trade-score-methodology" element={<TradeScoreMethodology />} />
          <Route path="/legal/terms" element={<Terms />} />
          <Route path="/legal/acceptable-use" element={<AcceptableUse />} />
          <Route path="/legal/cookies" element={<Cookies />} />
          <Route path="/legal/esign" element={<Esign />} />
          <Route path="/legal/aml-kyc" element={<AmlKyc />} />
          <Route path="/legal/demo-nda" element={<DemoNda />} />
          <Route path="/legal/do-not-sell" element={<DoNotSell />} />
          <Route path="/legal/dmca" element={<Dmca />} />
          {/* Demo subpath — landing page lets the visitor pick a role and
              get instantly logged into a curated, sandboxed demo account. */}
          <Route path="/demo" element={<DemoLanding />} />
          {/* Bank Sponsor Demo — public, sandboxed walkthrough of buyer +
              seller signup flows for sponsor-bank reviewers. No real KYB,
              Twilio, or Plaid calls fire from this surface. */}
          <Route path="/bank-demo" element={<BankDemoLanding />} />
          <Route path="/bank-demo/buyer" element={<BankDemoBuyerFlow />} />
          <Route path="/bank-demo/seller" element={<BankDemoSellerFlow />} />
          {/* Internal architecture map — blueprint of every portal, route,
              flow and integration. Not linked from public nav. */}
          <Route path="/architecture" element={<Architecture />} />
          <Route path="/flow-of-funds" element={<FlowOfFunds />} />
          <Route path="/investors" element={<InvestorPitch />} />
          <Route path="/investors/legacy" element={<InvestorPitchLegacy />} />

          {/* ── Invite accept (co-branded, opens inside portal) ── */}
          <Route path="/invites/:token" element={<AcceptInvite />} />

          {/* ── Two.inc embedded-checkout redirect bridge.
               Two.inc's hosted checkout iframe redirects here on completion so
               we can postMessage out to the parent TwoCheckoutModal. PUBLIC
               route — must not require auth because the iframe does not
               carry our JWT. */}
          <Route path="/two/done" element={<TwoDoneBridge />} />

          {/* ── Public PO portal (supplier-facing, no auth) ── */}
          <Route path="/p/po/:token" element={<PublicPO />} />
          <Route path="/s/:handle" element={<SellerProfilePage />} />
          <Route path="/s/:handle/catalog" element={<StorefrontCatalog />} />

          {/* /buyer/onboarding retired Feb 2026 — KYB now collected at /register.
              Redirect any stale link to the buyer dashboard. */}
          <Route path="/buyer/onboarding" element={<Navigate to="/buyer" replace/>}/>

          {/* ── Roadmap — available to every authenticated role ── */}
          <Route element={<AnyRoleRoute><AnyRolePortalShell/></AnyRoleRoute>}>
            <Route path="/roadmap" element={<Roadmap/>}/>
          </Route>

          <Route path="/banking/onboarding/done" element={<BankingOnboardingReturn />} />
          <Route path="/banking/onboarding/refresh" element={<BankingOnboardingReturn />} />

          <Route path="/seller" element={<RoleRoute role="seller"><SellerSetupProvider><SellerBillingProvider><PortalShell role="seller" /></SellerBillingProvider></SellerSetupProvider></RoleRoute>}>
            <Route index element={<SellerSetupGate><SellerBillingGate><SellerDashboard /></SellerBillingGate></SellerSetupGate>} />
            <Route path="orders" element={<SellerSetupGate><SellerBillingGate><SellerOrders /></SellerBillingGate></SellerSetupGate>} />
            <Route path="catalog" element={<SellerSetupGate><SellerBillingGate><SellerCatalog /></SellerBillingGate></SellerSetupGate>} />
            <Route path="catalog/setup" element={<SellerSetupGate><SellerBillingGate><CatalogSetupWizard /></SellerBillingGate></SellerSetupGate>} />
            <Route path="catalog/setup/:step" element={<SellerSetupGate><SellerBillingGate><CatalogSetupWizard /></SellerBillingGate></SellerSetupGate>} />
            <Route path="catalog/import" element={<SellerSetupGate><SellerBillingGate><SellerCatalogImport /></SellerBillingGate></SellerSetupGate>} />
            <Route path="catalog/broadcast" element={<SellerSetupGate><SellerBillingGate><SellerCatalogBroadcast /></SellerBillingGate></SellerSetupGate>} />
            <Route path="invoices" element={<SellerSetupGate><SellerBillingGate><SellerInvoices /></SellerBillingGate></SellerSetupGate>} />
            <Route path="wallet" element={<SellerSetupGate><SellerWallet /></SellerSetupGate>} />
            {/* Banking folded into Payouts (Oct 2026) — one place for money. */}
            <Route path="banking" element={<Navigate to="/seller/wallet#wallet" replace />} />
            <Route path="buyers" element={<SellerSetupGate><SellerBillingGate><SellerBuyers /></SellerBillingGate></SellerSetupGate>} />
            {/* /seller/shipping — only meaningful when the seller has flipped
                `offer_seller_arranged_shipping` in Settings → Operations. The
                page itself renders a soft "enable in settings" empty state when
                the flag is off so direct nav is graceful. */}
            <Route path="shipping" element={<SellerSetupGate><SellerBillingGate><SellerShipping /></SellerBillingGate></SellerSetupGate>} />
            <Route path="insurance" element={<SellerSetupGate><SellerBillingGate><SellerInsurance /></SellerBillingGate></SellerSetupGate>} />
            <Route path="dropship" element={<SellerSetupGate><SellerBillingGate><RequireAppInstalled appId="dropship"><SellerDropship /></RequireAppInstalled></SellerBillingGate></SellerSetupGate>} />
            <Route path="apps" element={<SellerSetupGate><SellerBillingGate><SellerAppStore /></SellerBillingGate></SellerSetupGate>} />
            <Route path="wms" element={<SellerSetupGate><SellerBillingGate><SellerWms /></SellerBillingGate></SellerSetupGate>} />
            <Route path="messages" element={<SellerSetupGate><SellerBillingGate><SellerMessages /></SellerBillingGate></SellerSetupGate>} />
            {/* Settings is always allowed — that's where the user goes to
                finish their setup checklist. allow=true bypasses the gate. */}
            <Route path="settings" element={<SellerSetupGate allow><SellerSettings /></SellerSetupGate>} />
            {/* Onboarding paywall — accessible while unsubscribed. */}
            <Route path="onboarding/plan" element={<SellerSetupGate allow><SellerOnboardingPlan /></SellerSetupGate>} />
            {/* Placeholders for sidebar entries whose feature is roadmap-only. */}
            <Route path="rfq" element={<SellerSetupGate><SellerBillingGate><SellerComingSoon /></SellerBillingGate></SellerSetupGate>} />
            <Route path="inventory" element={<SellerSetupGate><SellerBillingGate><SellerComingSoon /></SellerBillingGate></SellerSetupGate>} />
            <Route path="reports" element={<SellerSetupGate><SellerBillingGate><SellerComingSoon /></SellerBillingGate></SellerSetupGate>} />
            <Route path="ai" element={<SellerSetupGate><SellerBillingGate><SellerComingSoon /></SellerBillingGate></SellerSetupGate>} />
          </Route>

          <Route path="/buyer" element={<RoleRoute role="buyer"><SupplierProvider><SellerProfileDrawerProvider><PortalShell role="buyer" /></SellerProfileDrawerProvider></SupplierProvider></RoleRoute>}>
            <Route index element={<BuyerDashboard />} />
            <Route path="catalog" element={<BuyerCatalog />} />
            <Route path="cart" element={<BuyerCart />} />
            <Route path="orders" element={<BuyerOrders />} />
            <Route path="invoices" element={<BuyerInvoicesList />} />
            <Route path="payments" element={<BuyerPayments />} />
            {/* Banking folded into Payments (Oct 2026) — one place for money. */}
            <Route path="banking" element={<Navigate to="/buyer/payments#wallet" replace />} />
            <Route path="po-generator" element={<BuyerPOGenerator />} />
            <Route path="score" element={<BuyerScore />} />
            <Route path="capital" element={<BuyerCapital />} />
            <Route path="loans" element={<BuyerLoans />} />
            <Route path="insurance" element={<Navigate to="/buyer" replace />} />
            <Route path="shipping" element={<BuyerShipping />} />
            <Route path="suppliers" element={<BuyerSuppliers />} />
            <Route path="settings" element={<BuyerSettings />} />
            <Route path="integrations" element={<Navigate to="/buyer/settings#integrations" replace />} />
            <Route path="developers" element={<Navigate to="/buyer/settings#integrations" replace />} />
            <Route path="apps" element={<BuyerAppStore />} />
            <Route path="inventory" element={<BuyerInventory />} />
            <Route path="rfq" element={<BuyerRfq />} />
            <Route path="dropship" element={<RequireAppInstalled appId="dropship"><BuyerDropship /></RequireAppInstalled>} />
            <Route path="reports" element={<BuyerReports />} />
            <Route path="ai" element={<BuyerAI />} />
            {/* verqo Hub — value for buyers even before any seller invites them */}
            <Route path="po-inbox" element={<BuyerPOInbox />} />
            <Route path="messages" element={<BuyerMessages />} />
            <Route path="hub/financing" element={<BuyerHubFinancing />} />
          </Route>

          <Route path="/admin" element={<RoleRoute role="admin"><PortalShell role="admin" /></RoleRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="buyers" element={<AdminBuyers />} />
            <Route path="commerce" element={<AdminCommerce />} />
            {/* Audit-fix Feb 2026: alias /orders + /invoices + /reports → /commerce so direct URL navigation works. */}
            <Route path="orders" element={<Navigate to="/admin/commerce" replace />} />
            <Route path="invoices" element={<Navigate to="/admin/commerce" replace />} />
            <Route path="reports" element={<Navigate to="/admin/revenue" replace />} />
            <Route path="claims" element={<AdminClaims />} />
            <Route path="wallets" element={<AdminWallets />} />
            <Route path="dropship" element={<AdminDropship />} />
            <Route path="timeline" element={<AdminTimeline />} />
            <Route path="insurance" element={<AdminInsurance />} />
            <Route path="risk-engine" element={<AdminRiskEngine />} />
            <Route path="activity" element={<AdminActivity />} />
            <Route path="integrations" element={<AdminIntegrations />} />
            <Route path="verqo-shipping-accounts" element={<AdminShippingAccounts />} />
            <Route path="catalog-api" element={<AdminCatalogApi />} />
            <Route path="platform-fees" element={<AdminPlatformFees />} />
            <Route path="revenue" element={<AdminRevenue />} />
            <Route path="overrides" element={<AdminOverrides />} />
            <Route path="quotas" element={<AdminQuotas />} />
            <Route path="scopes" element={<Navigate to="/admin/security?tab=admins" replace />} />
            <Route path="security" element={<AdminSecurity />} />
            <Route path="stuck-ops" element={<AdminStuckOps />} />
            <Route path="bank-rail" element={<AdminBankRail />} />
            <Route path="shield" element={<AdminShield />} />
            <Route path="trade-score-disputes" element={<AdminTradeScoreDisputes />} />
            <Route path="portal-access" element={<AdminPortalAccess />} />
            <Route path="support" element={<AdminSupport />} />
            <Route path="support-console" element={<AdminSupportConsole />} />
            <Route path="underwriting" element={<AdminUnderwriting />} />
            <Route path="compliance" element={<AdminCompliance />} />
            <Route path="domains" element={<AdminDomains />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="team-notifications" element={<AdminTeamNotifications />} />
            <Route path="waitlist" element={<AdminWaitlist />} />
            <Route path="credit" element={<AdminCredit />} />
            <Route path="finance" element={<AdminFinance />} />
            <Route path="catalog" element={<AdminCatalog />} />
            <Route path="catalog/imports" element={<AdminCatalogImports />} />
            <Route path="legal" element={<AdminLegal />} />
            <Route path="coverage" element={<AdminCoverage />} />
            <Route path="master-policy-applications" element={<AdminMasterPolicy />} />
            <Route path="insurance/policies" element={<AdminInsurancePolicies />} />
            <Route path="operations" element={<AdminOperations />} />
            <Route path="payments-ops" element={<AdminPaymentsOps />} />
            <Route path="shipping" element={<AdminShipping />} />
            <Route path="webhooks" element={<AdminWebhooks />} />
            <Route path="partner-orgs" element={<AdminPartnerOrgs />} />
            {/* Admin Management Hub — P0/P1/P2 (May 2026) */}
            <Route path="finance-hub" element={<AdminMgmtFinance />} />
            <Route path="comms" element={<AdminMgmtComms />} />
            <Route path="platform-health" element={<AdminMgmtPlatform />} />
            <Route path="mgmt-hub" element={<AdminMgmtHub />} />
            <Route path="seller-trust" element={<AdminSellerTrust />} />
            <Route path="threat" element={<AdminThreatCenter />} />
            <Route path="compliance-docs" element={<AdminComplianceDocs />} />
            {/* HeyGen video studio · admin-only marketing tool */}
            <Route path="heygen-studio" element={<HeyGenStudio />} />
          </Route>

          {/* Banking partner portal — isolated layout, role-gated */}
          <Route path="/banking/login" element={<BankingLogin />} />
          <Route
            path="/banking"
            element={<PartnerRoleRoute roles={["banking_partner"]}><BankingPortalShell /></PartnerRoleRoute>}
          >
            <Route index element={<BankingOverview />} />
            <Route path="money-map" element={<BankingMoneyMap />} />
            <Route path="reconciliation" element={<BankingReconciliation />} />
            <Route path="regulatory" element={<BankingRegulatory />} />
            <Route path="privacy" element={<BankingPrivacy />} />
            <Route path="security-posture" element={<BankingSecurityPosture />} />
            <Route path="customer-profile" element={<BankingCustomerProfile />} />
            <Route path="customer-profile/:userId" element={<BankingCustomerProfile />} />
            <Route path="aml-typologies" element={<BankingAmlTypologies />} />
            <Route path="alerts-push" element={<BankingAlerts />} />
            <Route path="policy-trace" element={<BankingPolicyTrace />} />
            <Route path="policy-trace/:txnId" element={<BankingPolicyTrace />} />
            <Route path="behavioral" element={<BankingBehavioral />} />
            <Route path="cyber" element={<BankingCyber />} />
            <Route path="ops-defense" element={<BankingOpsDefense />} />
            <Route path="model-risk" element={<BankingModelRisk />} />
            <Route path="bsa-officer" element={<BankingBsaOfficer />} />
            <Route path="sanctions-coverage" element={<BankingSanctionsCoverage />} />
            <Route path="pre-auth-simulator" element={<BankingPreAuthSimulator />} />
            <Route path="watchtower" element={<BankingWatchtower />} />
            <Route path="network-risk" element={<BankingNetworkRisk />} />
            <Route path="encryption-posture" element={<BankingEncryptionPosture />} />
            <Route path="auth-posture" element={<BankingAuthPosture />} />
            <Route path="regulatory-calendar" element={<BankingRegulatoryCalendar />} />
            <Route path="predictive-forecast" element={<BankingPredictive />} />
            <Route path="crr" element={<BankingCrr />} />
            <Route path="resilience" element={<BankingGlba />} />
            <Route path="fair-lending" element={<BankingFairLending />} />
            <Route path="nacha" element={<BankingNacha />} />
            <Route path="liquidity" element={<BankingLiquidity />} />
            <Route path="defense-posture" element={<BankingDefense />} />
            <Route path="examiner-links" element={<BankingExaminerLinks />} />
            <Route path="vendor-concentration" element={<BankingVendorConcentration />} />
            <Route path="onboarding-funnel" element={<BankingFunnel />} />
            <Route path="diligence" element={<BankingDiligencePacket />} />
            <Route path="transactions" element={<BankingTransactions />} />
            <Route path="webhooks" element={<BankingWebhooks />} />
            <Route path="chargebacks" element={<BankingChargebacks />} />
            <Route path="api-health" element={<BankingApiHealth />} />
            <Route path="reports" element={<PartnerReports portalKey="banking" portalName="Banking" theme="sky" datasets={BANKING_DATASETS} />} />
          </Route>

          {/* Lender partner portal — Phase PP-2 · violet theme */}
          <Route
            path="/lender/login"
            element={
              <PartnerLogin
                portalKey="lender"
                role="lender_partner"
                portalName="Lender"
                portalIcon={Landmark}
                theme="violet"
                tagline={"Your loan book\nat a glance."}
                proofs={[
                  { icon: BanknoteIcon, label: "Live disbursements + repayments + delinquency buckets." },
                  { icon: ShieldCheckIcon, label: "ECOA-compliant adverse-action audit trail." },
                ]}
              />
            }
          />
          <Route
            path="/lender"
            element={
              <PartnerRoleRoute roles={["lender_partner"]}>
                <PartnerPortalShell
                  role="lender_partner"
                  portalName="Lender"
                  portalIcon={Landmark}
                  theme="violet"
                  whoamiPath="/partner/lender/whoami"
                  logoutTo="/lender/login"
                  nav={[
                    { to: "/lender", label: "Overview", icon: LayoutDashboardIcon, end: true },
                    { to: "/lender/wallet", label: "Wallet", icon: BanknoteIcon },
                    { to: "/lender/active-loans", label: "Active loans", icon: FileTextIcon },
                    { to: "/lender/buyer-underwriting", label: "Buyer underwriting", icon: ShieldIcon },
                    { to: "/lender/seller-underwriting", label: "Seller underwriting", icon: ShieldIcon },
                    { to: "/lender/aging", label: "Aging", icon: AlertTriangleIcon },
                    { to: "/lender/forecast", label: "Forecast", icon: SendIcon },
                    { to: "/lender/pending-grants", label: "Pending grants", icon: GavelIcon },
                    { to: "/lender/disbursements", label: "Disbursements", icon: SendIcon },
                    { to: "/lender/repayments", label: "Repayments", icon: BanknoteIcon },
                    { to: "/lender/delinquencies", label: "Delinquencies", icon: AlertTriangleIcon },
                    { to: "/lender/adverse-notices", label: "Adverse notices", icon: GavelIcon },
                    { to: "/lender/reports", label: "Reports", icon: DownloadIcon },
                  ]}
                />
              </PartnerRoleRoute>
            }
          >
            <Route index element={<LenderOverview />} />
            <Route path="wallet" element={<LenderWallet />} />
            <Route path="active-loans" element={<LenderActiveLoans />} />
            <Route path="buyer-underwriting" element={<LenderBuyerUnderwriting />} />
            <Route path="seller-underwriting" element={<LenderSellerUnderwriting />} />
            <Route path="aging" element={<LenderAging />} />
            <Route path="forecast" element={<LenderForecast />} />
            <Route path="pending-grants" element={<LenderPendingGrants />} />
            <Route path="loanbook" element={<LenderLoanbook />} />
            <Route path="disbursements" element={<LenderDisbursements />} />
            <Route path="repayments" element={<LenderRepayments />} />
            <Route path="delinquencies" element={<LenderDelinquencies />} />
            <Route path="adverse-notices" element={<LenderAdverseNotices />} />
            <Route path="reports" element={<PartnerReports portalKey="lender" portalName="Lender" theme="violet" datasets={LENDER_DATASETS} />} />
          </Route>

          {/* Insurance partner portal — Phase PP-3 · emerald theme */}
          <Route
            path="/insurance/login"
            element={
              <PartnerLogin
                portalKey="insurance"
                role="insurance_partner"
                portalName="Insurance"
                portalIcon={Shield}
                theme="emerald"
                tagline={"Coverage + claims\nin one console."}
                proofs={[
                  { icon: ShieldCheckIcon, label: "Real-time view of every cover you underwrite." },
                  { icon: Coins, label: "Approve · deny · pay claims with one-click decision flow." },
                ]}
              />
            }
          />
          <Route
            path="/insurance"
            element={
              <PartnerRoleRoute roles={["insurance_partner"]}>
                <PartnerPortalShell
                  role="insurance_partner"
                  portalName="Insurance"
                  portalIcon={Shield}
                  theme="emerald"
                  whoamiPath="/partner/insurance/whoami"
                  logoutTo="/insurance/login"
                  nav={[
                    { to: "/insurance", label: "Overview", icon: LayoutDashboardIcon, end: true },
                    { to: "/insurance/wallet", label: "Wallet", icon: BanknoteIcon },
                    { to: "/insurance/forecast", label: "Forecast", icon: ActivityIcon },
                    { to: "/insurance/policies", label: "Policies", icon: Shield },
                    { to: "/insurance/events", label: "Events", icon: ActivityIcon },
                    { to: "/insurance/aging", label: "Takeover Aging", icon: AlertTriangleIcon },
                    { to: "/insurance/loans-roster", label: "Loans Roster", icon: ScrollTextIcon },
                    { to: "/insurance/takeover-queue", label: "Takeover Queue", icon: AlertTriangleIcon },
                    { to: "/insurance/collections", label: "Collections", icon: FileTextIcon },
                    { to: "/insurance/analytics", label: "Analytics", icon: ActivityIcon },
                    { to: "/insurance/advanced", label: "Advanced", icon: ActivityIcon },
                    { to: "/insurance/covers", label: "Covers", icon: Shield },
                    { to: "/insurance/claims", label: "Claims", icon: FileWarningIcon },
                    { to: "/insurance/applications", label: "Applications", icon: ScrollTextIcon },
                    { to: "/insurance/reports", label: "Reports", icon: DownloadIcon },
                  ]}
                />
              </PartnerRoleRoute>
            }
          >
            <Route index element={<InsuranceOverview />} />
            <Route path="wallet" element={<InsuranceWallet />} />
            <Route path="forecast" element={<InsuranceForecast />} />
            <Route path="policies" element={<InsurancePolicies />} />
            <Route path="events" element={<InsuranceEvents />} />
            <Route path="aging" element={<InsuranceTakeoverAging />} />
            <Route path="advanced" element={<InsuranceAdvancedAnalytics />} />
            <Route path="loans-roster" element={<InsuranceLoansRoster />} />
            <Route path="takeover-queue" element={<InsuranceTakeoverQueue />} />
            <Route path="collections" element={<InsuranceCollections />} />
            <Route path="analytics" element={<InsuranceAnalytics />} />
            <Route path="covers" element={<InsuranceCovers />} />
            <Route path="claims" element={<InsuranceClaims />} />
            <Route path="applications" element={<InsuranceApplications />} />
            <Route path="reports" element={<PartnerReports portalKey="insurance" portalName="Insurance" theme="emerald" datasets={INSURANCE_DATASETS} />} />
          </Route>

          {/* Carrier partner portal — Phase PP-4 · amber theme */}
          <Route
            path="/carrier/login"
            element={
              <PartnerLogin
                portalKey="carrier"
                role="carrier_partner"
                portalName="Carrier"
                portalIcon={TruckIcon}
                theme="amber"
                tagline={"Pickups · POD ·\nexceptions · invoices."}
                proofs={[
                  { icon: PackageIcon, label: "Every shipment assigned to your fleet · live status board." },
                  { icon: MapPin, label: "Submit POD + carrier invoices · audit-logged for AP." },
                ]}
              />
            }
          />
          <Route
            path="/carrier"
            element={
              <PartnerRoleRoute roles={["carrier_partner"]}>
                <PartnerPortalShell
                  role="carrier_partner"
                  portalName="Carrier"
                  portalIcon={TruckIcon}
                  theme="amber"
                  whoamiPath="/partner/carrier/whoami"
                  logoutTo="/carrier/login"
                  nav={[
                    { to: "/carrier", label: "Overview", icon: LayoutDashboardIcon, end: true },
                    { to: "/carrier/shipments", label: "Shipments", icon: PackageIcon },
                    { to: "/carrier/reports", label: "Reports", icon: DownloadIcon },
                  ]}
                />
              </PartnerRoleRoute>
            }
          >
            <Route index element={<CarrierOverview />} />
            <Route path="shipments" element={<CarrierShipments />} />
            <Route path="reports" element={<PartnerReports portalKey="carrier" portalName="Carrier" theme="amber" datasets={CARRIER_DATASETS} />} />
          </Route>
        </Routes>
        </AppModeProvider>
        </TenantHostProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
